exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".load-more-wrapper[data-v-19dfcb71]{height:100%;overflow-y:auto;-webkit-overflow-scrolling:touch;transition-duration:.3s}.load-more-wrapper .load-end[data-v-19dfcb71],.load-more-wrapper .load-more[data-v-19dfcb71]{color:#aea699;font-size:.26rem;margin:.3rem 0;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-19dfcb71","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/myLoadMore.vue
// module id = 208
// module chunks = 0